export default {
  // url without any query string
  randomString: function (l) {
    var s = "";
    while (s.length < l && l > 0) {
      var r = Math.random();
      s +=
        r < 0.1
          ? Math.floor(r * 100)
          : String.fromCharCode(Math.floor(r * 26) + (r > 0.5 ? 97 : 65));
    }
    return s;
  },
  numberWithCommas: function (n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  elementInViewport: function (el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top >= window.pageYOffset &&
      left >= window.pageXOffset &&
      top + height <= window.pageYOffset + window.innerHeight &&
      left + width <= window.pageXOffset + window.innerWidth
    );
  },
};
